const FollowIcon = () => {
  return (
<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="4" width="48" height="48" rx="24" fill="#056CF2" fill-opacity="0.15"/>
<rect x="4" y="4" width="48" height="48" rx="24" stroke="#589DF7" stroke-opacity="0.1" strokeWidth="8"/>
<g clip-path="url(#clip0_160_198)">
<path d="M30 30.252V32.342C29.0949 32.022 28.1263 31.9239 27.1754 32.0558C26.2245 32.1877 25.3192 32.5459 24.5354 33.1002C23.7517 33.6545 23.1123 34.3888 22.6712 35.2414C22.23 36.094 21.9998 37.04 22 38H20C19.9995 36.7788 20.2787 35.5737 20.816 34.4771C21.3533 33.3804 22.1345 32.4214 23.0998 31.6733C24.0651 30.9253 25.1889 30.4082 26.3849 30.1617C27.581 29.9152 28.8176 29.9467 30 30.252ZM28 29C24.685 29 22 26.315 22 23C22 19.685 24.685 17 28 17C31.315 17 34 19.685 34 23C34 26.315 31.315 29 28 29ZM28 27C30.21 27 32 25.21 32 23C32 20.79 30.21 19 28 19C25.79 19 24 20.79 24 23C24 25.21 25.79 27 28 27ZM33.793 35.914L37.328 32.379L38.743 33.793L33.793 38.743L30.257 35.207L31.672 33.793L33.793 35.914Z" fill="#076EFF"/>
</g>
<defs>
<clipPath id="clip0_160_198">
<rect width="24" height="24" fill="white" transform="translate(16 16)"/>
</clipPath>
</defs>
</svg>
  )
}

export default FollowIcon